import api from '@/api/api'
export const authCodeMixin = {
  data() {
    return {
      codeUrl: '',
      imgCodeTime: '',
      smsCodeTime: ''
    }
  },
  created() {
    this.imgCodeTime = Date.parse(new Date())
    this.getPin(this.imgCodeTime)
  },
  methods: {
    getPin(timeStamp) {
      this.codeUrl = `/api/web/pin/getPin?timeStamp=${timeStamp}`
    },
    getSms(formData) {
      api.authCode.sms(formData).then(res => {
        if (res.data.code === 200) {
          this.errorMsg = ''
          this.smsErrorMsg = ''
        } else if (res.data.code === 300) {
          this.errorMsg = '图片验证码已过期!'
          this.handleRefreshCode()
          clearInterval(this.timeInterval)
          this.isDisabled = false
          this.seconds = 60
        } else if (res.data.code === 301) {
          this.errorMsg = '图片验证码错误！'
          this.handleRefreshCode()
          clearInterval(this.timeInterval)
          this.isDisabled = false
          this.seconds = 60
        } else if (res.data.code === 302) {
          this.smsErrorMsg = '短信验证码超过最大发送次数！'
        } else if (res.data.code === 303) {
          this.smsErrorMsg = '短信验证码过期！'
        } else if (res.data.code === 304) {
          this.smsErrorMsg = '短信验证码过期！'
        } else {
          this.errorMsg = ''
          this.smsErrorMsg = ''
        }
      })
    },
    handleRefreshCode() {
      // this.errorMsg = ''
      this.imgCodeTime = Date.parse(new Date())
      this.getPin(this.imgCodeTime)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/authCodeMixin.js